module.exports = __webpack_public_path__ + "diners.svg?81c989";


//////////////////
// WEBPACK FOOTER
// ./client/assets/card/diners.svg
// module id = 250
// module chunks = 0